import React, { useState } from "react";
import "../styles/ReportIncident.scss";
import Header from "../components/Header";
import Page1 from "../components/ReportIncident/Page1";
import Page2 from "../components/ReportIncident/Page2";
import Page3 from "../components/ReportIncident/Page3";
import Page4 from "../components/ReportIncident/Page4";
import ThanksPage from "../components/ReportIncident/ThanksPage";
import UpdatesPage from "../components/ReportIncident/UpdatesPage";
import { useTranslation } from "react-i18next";
import LinkExpired from "../components/ReportIncident/LinkExpired";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import { updateRedux, update_report_no, verify_status } from "../redux/commonReducer";
import { useDispatch, useSelector } from "react-redux";
import { onNextButtonValidation, onOTPrequestValidation } from "../utils/validation";
import Head from "../constants/Head";
import axios from "axios";
import Footer from "../components/Footer";

export default function ReportIncident({ page }) {
  const location = useLocation();
  const lang = location.pathname.split("/")[1];
  const dispatch = useDispatch()
  const pageRoute = useParams()
  const navigate = useNavigate()

  const verifyStatus = useSelector(verify_status);
  const update_report_incident_no = useSelector(update_report_no);

  const [stage, setStage] = useState(1);
  const [inputs, setInputs] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone_number: "",
    files: [],
    country_code: "+971",
    incident_type: "",
    entity: "",
    date: "",
    reported_elsewhere: "",
    description: "",
    agree_conditions: false
  });
  const [inputErrors, setInputErrors] = useState({});
  const [pageAccess, setPageAccess] = useState({
    1: true,
    2: false,
    3: false,
    4: false,
  });
  const [timer, setTimer] = useState("00:00:00");
  const [intervalId, setIntervalId] = useState(null)

  useEffect(() => {
    // console.log(page, 'pageroute')
    if (page === 'update') {
      setStage(6)
    } else {
      if (Object.keys(pageRoute).length === 0) { setStage(1) }
      else if (pageRoute.page === 'personal_information') { setStage(2) }
      else if (pageRoute.page === 'incident_report') { setStage(3) }
      else if (pageRoute.page === 'review_submit') { setStage(4) }
    }
  }, [pageRoute])

  const checkPageInputStatus = async (page) => {
    if (page === 1) {
      if (!inputs.agree_conditions) {
        let checkBoxError = document.querySelector('#agree_conditions')
        // console.log(checkBoxError, 'condition error element')
        if (checkBoxError) checkBoxError.scrollIntoView()
        setInputErrors(s => ({ ...s, agree_conditions: true }))
        return false
      } else return true

    } else if (page === 2) {
      const isValidated = await onOTPrequestValidation(
        {
          first_name: inputs.first_name,
          last_name: inputs.last_name,
          email: inputs.email,
          phone_number: inputs.phone_number,
          emirates_id: inputs.emirates_id,
        },
        setInputErrors
      );
      // console.log(isValidated, 'isvalidated')
      return isValidated && verifyStatus
    } else if (page === 3) {
      const isValidated = await onNextButtonValidation(
        {
          incident_type: inputs.incident_type._id,
          entity: inputs.entity,
          date: inputs.date,
          reported_elsewhere: inputs.reported_elsewhere,
          description: inputs.description,
          files: inputs.files
        },
        setInputErrors
      );
      return isValidated
    }
  }

  useEffect(() => {
    if (!inputs.agree_conditions && page !== 'update' && stage !== 5 && stage !== 7) {
      navigate(`/${lang}/report_incident`)
    }
  }, [inputs.agree_conditions, page, stage])

  useEffect(() => {
    return () => {
      dispatch(
        updateRedux({ key: "showOtpSection", value: false })
      )
    }
  }, [])

  useEffect(() => {
    dispatch(updateRedux({ key: "verify_status", value: false }));
    dispatch(updateRedux({ key: "hide_send_otp", value: false }));
    dispatch(updateRedux({ key: "otp_loader", value: false }));
  }, [])

  const getBestServer = async () => {
    const det = await axios.get('https://api.ipify.org')
    dispatch(updateRedux({ key: "ip_address", value: det?.data }));
    // console.log(det?.data)
  }

  useEffect(() => {
    getBestServer()
  }, [])

  // useEffect(() => {
  //   if (page === 'update') {
  //     setStage(6)
  //   } else if (page === 'firstPage') {
  //     setStage(1)
  //   }
  // }, [page])

  useEffect(() => {
    setPageAccess(s => ({
      ...s,
      2: inputs.agree_conditions,
      3: verifyStatus && !inputErrors.last_name && !inputErrors.first_name && !inputErrors.email,
      4: inputs.incident_type !== "" &&
        inputs.entity?.trim() !== "" &&
        inputs.date !== "" &&
        inputs.reported_elsewhere !== "" &&
        inputs.description?.trim() !== "" && !inputErrors.last_name && !inputErrors.first_name && !inputErrors.email
    }))
  }, [inputs, verifyStatus])

  // console.log(inputs, 'inputs')
  // console.log(stage, 'stage')
  // console.log(inputErrors, 'inputErrors')
  // console.log(checkPageInputStatus(2), 'inputs')
  // console.log(pageAccess, 'pageAccess')

  const { t } = useTranslation();

  return (
    <>
      <Head title={t('html_title.report_incident')} metatitle={t('html_title.report_incident')} metaDescription={t('html_title.report_incident')} />
      <div className={"Report-incident" + (lang === "ar" ? " rtl" : " ltr")}>
        <section className="banner container">
          <img src="./assets/img/incident.jpg" className="banner__background w-100" />
          <Header />
          {(stage === 6) ? (
            update_report_incident_no &&
            <div className="banner-content container">
              <h1>{t("incident_report")}</h1>
              {
                lang === 'ar' ?
                  <p className="incident-number">
                    {update_report_incident_no && update_report_incident_no} : {t("incident_no")}
                  </p>
                  : lang === 'en' ?
                    <p className="incident-number">
                      {t("incident_no")} : {update_report_incident_no && update_report_incident_no}
                    </p>
                    : null
              }
            </div>
          ) : (stage === 7 || stage === 8) ? null : (
            <div className="banner-content container">
              <h1>{t("incident_report")}</h1>
              <div className="form-page-progress">
                <span className="stages">
                  <i
                    className={stage >= 1 ? "done" : ""}
                    onClick={() => {
                      // setStage(1)
                      navigate(`/${lang}/report_incident`)
                    }}
                  >
                    1
                  </i>
                  <p>{t("introduction")}</p>
                </span>
                <span
                  className={`progress-line ${stage >= 2 ? " done" : ""}`}
                ></span>
                <span className="stages">
                  <i
                    className={stage >= 2 ? "done" : ""}
                    onClick={() => checkPageInputStatus(1).then(status => status && (
                      // setStage(2)
                      navigate(`/${lang}/report_incident/personal_information`)
                    ))}
                  >
                    2
                  </i>
                  <p>{t("personal_information")}</p>
                </span>
                <span
                  className={`progress-line ${stage >= 3 ? " done" : ""}`}
                ></span>
                <span className="stages">
                  <i
                    className={stage >= 3 ? "done" : ""}
                    onClick={() => Promise.all([checkPageInputStatus(1), checkPageInputStatus(2)]).then(res => !res.includes(false) && (
                      // setStage(3)
                      navigate(`/${lang}/report_incident/incident_report`)
                    ))}
                  >
                    3
                  </i>
                  <p>{t("incident_report")}</p>
                </span>
                <span
                  className={`progress-line ${stage >= 4 ? " done" : ""}`}
                ></span>
                <span className="stages">
                  <i
                    className={stage >= 4 ? "done" : ""}
                    onClick={() => Promise.all([checkPageInputStatus(1), checkPageInputStatus(2), checkPageInputStatus(3)]).then(res => !res.includes(false) && (
                      // setStage(4)
                      navigate(`/${lang}/report_incident/review_submit`)
                    ))}
                  >
                    4
                  </i>
                  <p>{t("review_and_submit")}</p>
                </span>
              </div>
            </div>
          )}
        </section>
        <section className="pages">
          {stage === 1 ? (
            <Page1
              setStage={setStage}
              setInputs={setInputs}
              inputs={inputs}
              pageAccess={pageAccess}
              inputErrors={inputErrors}
              setInputErrors={setInputErrors}
            />
          ) : stage === 2 ? (
            <Page2
              setStage={setStage}
              setInputs={setInputs}
              inputs={inputs}
              setInputErrors={setInputErrors}
              inputErrors={inputErrors}
              timer={timer}
              setTimer={setTimer}
              intervalId={intervalId}
              setIntervalId={setIntervalId}
            />
          ) : stage === 3 ? (
            <Page3
              setStage={setStage}
              setInputs={setInputs}
              inputs={inputs}
              setInputErrors={setInputErrors}
              inputErrors={inputErrors}
            />
          ) : stage === 4 ? (
            <Page4 setStage={setStage} setInputs={setInputs} inputs={inputs} />
          ) : stage === 5 ? (
            <ThanksPage />
          ) : stage === 6 ? (
            <UpdatesPage setStage={setStage} />
          ) : stage === 7 ? (
            <LinkExpired />
          ) : stage === 8 ? (
            <LinkExpired type={'invalid'} />
          ) : null}
        </section>
        <Footer />
      </div>
    </>

  );
}
